import "@/App.css";
import {
  ROUTE_DASHBOARD,
  ROUTE_HOME,
  ROUTE_LOGGING_IN,
  ROUTE_LOGIN_OUT,
} from "@/constants/routes.constants";
import PageChat from "@/pages/Chat/chat.page";
import PageDashboard from "@/pages/Dashboard/dashboard.page";
import LoggingInPage from "@/pages/LoggingIn/loggingIn.page";
import PageLogin from "@/pages/Login/login.page";
import PageNotFound from "@/pages/NotFound/notfound.page";
import { NetworkStatusProvider } from "@/services/NetworkContext/networkStatusProvider";
import PinAuthentication from "@/services/PinAuthentication";
import ProtectedRoute from "@/services/ProtectedRoute";
import { Toaster } from "@/shadcn/components/ui/sonner";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router";

function App() {
  return (
    <div className={`App h-svh w-svw overflow-hidden`}>
      <NetworkStatusProvider>
        <Router>
          <Routes>
            <Route path={ROUTE_LOGIN_OUT} element={<PageLogin />} />
            <Route path={ROUTE_LOGGING_IN} element={<LoggingInPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<PinAuthentication />}>
                <Route path={ROUTE_DASHBOARD} element={<PageDashboard />} />
                <Route path={ROUTE_HOME} element={<PageChat />} />
                <Route path={`${ROUTE_HOME}/:chatID`} element={<PageChat />} />
                <Route path="*" element={<PageNotFound />} />
              </Route>
            </Route>
            <Route path="/" element={<Navigate to={ROUTE_HOME} replace />} />
          </Routes>
        </Router>
        <Toaster
          position="top-right"
          richColors
          closeButton
          offset={{
            top: "4rem",
          }}
          mobileOffset={{ top: "5rem", left: "10%" }}
          visibleToasts={1}
          expand={true}
        />
      </NetworkStatusProvider>
    </div>
  );
}

export default App;
